import { useState } from 'react';
import ButtonGenerate from './ButtonGenerate';

interface Props {
    isGenerating: boolean;
    onTranscribe: () => Promise<unknown>;
    onClickGenerate?: () => void;
}

const ButtonGenerateLegacyTranscription = ({
    isGenerating,
    onTranscribe,
    onClickGenerate,
}: Props) => {
    const [userHasRequestedGeneration, setUserHasRequestedGeneration] =
        useState(false);

    const handleClick = () => {
        onClickGenerate?.();
        setUserHasRequestedGeneration(true);
        onTranscribe().finally(() => setUserHasRequestedGeneration(false));
    };

    return (
        <ButtonGenerate
            generationIsInProgress={isGenerating || userHasRequestedGeneration}
            onClick={handleClick}
        />
    );
};

export default ButtonGenerateLegacyTranscription;
